const megaMenu = () => {
    const mobileMenuToggle = document.querySelector('[data-menu-drawer-toggle]');
    const menuDrawerMegaMenuItems = document.querySelectorAll('[data-menu-drawer-mega-menu-item]');
    const accordions = document.querySelectorAll('[data-mega-menu-accordion]');
    const megaMenus = document.querySelectorAll('[data-mega-menu]');
    // Mobile Menu - Toggle
    mobileMenuToggle?.addEventListener('click', () => {
        document.body.classList.toggle('menu-drawer--open');
        setTimeout(() => {
            menuDrawerMegaMenuItems.forEach((item) => {
                item.classList.remove('menu-item--mega-menu-open');
            });
            accordions.forEach((accordion) => {
                closeAccordion(accordion);
            });
        }, 400);
    });
    // Mobile Menu - Panels
    menuDrawerMegaMenuItems.forEach((item) => {
        const title = item.querySelector('[data-menu-drawer-mega-menu-item-title]');
        const backButton = item.querySelector('[data-menu-drawer-mega-menu-item-back-button]');
        title.addEventListener('click', () => {
            item.classList.add('menu-item--mega-menu-open');
        });
        backButton.addEventListener('click', () => {
            item.classList.remove('menu-item--mega-menu-open');
        });
    });
    // Mobile Menu - Accordions
    const openAccordion = (accordion) => {
        const content = accordion.querySelector('[data-accordion-content]');
        accordion.classList.add('panel__group--open');
        content.style.maxHeight = content.scrollHeight + 'px';
    };
    const closeAccordion = (accordion) => {
        const content = accordion.querySelector('[data-accordion-content]');
        accordion.classList.remove('panel__group--open');
        content.style.maxHeight = null;
    };
    accordions.forEach((accordion) => {
        const intro = accordion.querySelector('[data-accordion-title]');
        const content = accordion.querySelector('[data-accordion-content]');
        if (intro && content) {
            intro.onclick = () => {
                if (content.style.maxHeight) {
                    closeAccordion(accordion);
                }
                else {
                    accordions.forEach((accordion) => closeAccordion(accordion));
                    openAccordion(accordion);
                }
            };
        }
    });
    // Desktop Mega Menu Hover Effects
    megaMenus.forEach((menu) => {
        let currentHoverImage;
        const defaultImage = menu.getAttribute('data-mega-menu-default-image');
        const titles = menu.querySelectorAll('[data-mega-menu-title-id]');
        const panels = menu.querySelectorAll('[data-mega-menu-panel-id]');
        const hoverImageLinks = menu.querySelectorAll('[data-hover-image]');
        const hoverImageContainer = menu.querySelector('[data-mega-menu-image]');
        const updateImage = (imageString) => {
            setTimeout(() => {
                hoverImageContainer.innerHTML = imageString;
                const image = hoverImageContainer.querySelector('img');
                image.onload = () => {
                    hoverImageContainer.style.setProperty('opacity', '1');
                };
            }, 200);
        };
        titles.forEach((title) => {
            const ID = title.getAttribute('data-mega-menu-title-id');
            title.addEventListener('mouseover', () => {
                panels.forEach((panel) => {
                    panel.classList.remove('group__panel--active');
                });
                titles.forEach((title) => {
                    title.classList.remove('group__title--active');
                });
                title.classList.add('group__title--active');
                menu.querySelector('[data-mega-menu-panel-id="' + ID + '"]')?.classList.add('group__panel--active');
            });
        });
        hoverImageLinks.forEach((link) => {
            link.addEventListener('mouseover', () => {
                const hoverImage = link.getAttribute('data-hover-image');
                const hoverImageTitle = link.getAttribute('data-hover-image-title');
                const currentImageTitle = hoverImageContainer.getAttribute('data-mega-menu-image-title');
                if (hoverImage != 'default') {
                    if (currentImageTitle != hoverImageTitle) {
                        hoverImageContainer.style.setProperty('opacity', '0');
                        hoverImageContainer.setAttribute('data-mega-menu-image-title', hoverImageTitle);
                        updateImage(hoverImage);
                    }
                }
                else {
                    if (currentImageTitle != 'default') {
                        hoverImageContainer.style.setProperty('opacity', '0');
                        hoverImageContainer.setAttribute('data-mega-menu-image-title', 'default');
                        updateImage(defaultImage);
                    }
                }
            });
        });
        // Reset Menu
        menu.addEventListener('mouseleave', () => {
            currentHoverImage = '';
            panels.forEach((panel) => {
                panel.classList.remove('group__panel--active');
            });
            titles.forEach((title) => {
                title.classList.remove('group__title--active');
            });
            updateImage(defaultImage);
        });
    });
};
export { megaMenu };
